import Sales from 'dash/js/services/Sales'
import FilterStruct from 'dash/js/schemas/filters.struct'

/**
 * @param commit
 * @param rootState
 * @param rootGetters
 * @param dispatch
 * @param data
 */
export const retrieveSales = ({ commit }, data) => {
  let params = data ? data : FilterStruct

  let filters = Object.assign(params, { by: 'updated-between', type: 'historics' })

  Sales.retrieve(filters, response => commit('retrieveSales', response.data))
}

/**
 * @param commit
 * @param state
 * @param data
 */
export const pushItemIntoArray = ({ commit }, data) => commit('pushItemIntoArray', data)

/**
 * @param commit
 * @param data
 */
export const popItemFromArray = ({ commit }, data) => commit('popItemFromArray', data)

/**
 * @param commit
 */
export const cleanArray = ({ commit }) => commit('cleanArray')

/**
 * @param dispatch
 * @param state
 * @param vm
 */
export const checkboxMaster = ({ dispatch, state }, { vm }) => {
  if (state.selectedSales.length == 0) {
    state.sales.forEach((item,index) => {
      dispatch('pushItemIntoArray', item.id)
      vm.$children[index + 2].$refs[`sale-checkbox-${item.id}`].isChecked = true
    })
  }
  else {
    dispatch('cleanArray')

    state.sales.forEach((item, index) => {
      vm.$children[index + 2].$refs[`sale-checkbox-${item.id}`].isChecked = false
    })
  }
}
